var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationPointer = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "68px",
  height: "82px",
  viewBox: "0 0 68 82",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "8DE12DCA-0D33-4299-95DF-E4878D44F6B2") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 34.2857143 0 34.2857143 48 0 48"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Home",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "HOME",
  transform: "translate(-154.000000, -448.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(168.000000, 448.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  strokeOpacity: 0.324191434,
  stroke: "#6467EF",
  strokeWidth: 14,
  fillOpacity: 0.734730114,
  fill: "#6467EF",
  cx: 20,
  cy: 48,
  r: 27
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#6467EF",
  strokeWidth: 3,
  fill: "#FFFFFF",
  cx: 20,
  cy: 47,
  r: 4.5
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(3.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.1107381,22.782892 C20.4648119,22.8249576 23.2178667,20.1756477 23.2541133,16.8730833 C23.2903599,13.5564971 20.6148559,10.8494501 17.2649969,10.8131581 C13.8316863,10.7760414 11.0946475,13.3601908 11.0347985,16.6940982 C10.9749495,20.048626 13.6605687,22.7400015 17.1107381,22.782892 M14.1933093,44.5489687 C10.0932301,39.5406843 6.33538623,34.3080498 3.42470093,28.533511 C1.97399448,25.655727 0.798930678,22.6806147 0.238372983,19.4935246 C-0.994011001,12.4858855 2.63992016,5.27616647 9.10782872,1.96040503 C19.3453824,-3.28872575 31.6869241,2.48003929 33.972145,13.5894897 C34.6372277,16.8169958 34.1870957,19.9603707 33.16039,23.0534317 C31.718113,27.3952646 29.4977988,31.3609812 27.0035278,35.1889536 C24.1282461,39.6033703 20.8980851,43.7596195 17.3914384,47.7113143 C17.3290606,47.7814237 17.262468,47.8482338 17.1174817,48 C16.1169073,46.8213375 15.1348776,45.701237 14.1933093,44.5489687 Z",
  id: "Fill-1",
  fill: "#6467EF",
  mask: "url(#mask-2)"
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationPointer);
export default ForwardRef;